<script setup>
import { ref } from 'vue';
import Button from 'primevue/button';
const props = defineProps({
    pareceres: Array
})
function ordenarPorNomeDeUsuario(array) {
    array.sort((a, b) => {
        const nomeA = a.users.nome.toUpperCase(); 
        const nomeB = b.users.nome.toUpperCase();


        if (nomeA < nomeB) {
            return -1;
        }
        if (nomeA > nomeB) {
            return 1;
        }


        return 0;
    });

    return array;
}
function copiarParaAreaDeTransferencia(texto) {
    navigator.clipboard.writeText(texto).then(() => {
       isCopiado.value = true
    }).catch(err => {
        console.error("Falha ao copiar texto: ", err);
    });
}
const isCopiado = ref(false)
async function copiar() {
    let pareceresOrdenados = ordenarPorNomeDeUsuario(props.pareceres);
    copiarParaAreaDeTransferencia(JSON.stringify(pareceresOrdenados))
}

</script>

<template>
    <Button :icon="isCopiado ? 'pi pi-check' : 'pi pi-copy'" :label="isCopiado ? 'Copiado!' : 'Copiar'" class="hidden lg:block" @click="copiar" />
</template>